import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import './index.scss'
import { Divider } from 'primereact/divider'
import 'primeicons/primeicons.css'

export default function Footer() {
  const [language, setLanguage] = useState(localStorage.getItem('lang') || 'es')

  useEffect(() => {
    const handleLanguageChange = () => {
      setLanguage(localStorage.getItem('lang') || 'es')
    }

    window.addEventListener('languageChange', handleLanguageChange)
    return () =>
      window.removeEventListener('languageChange', handleLanguageChange)
  }, [])

  return (
    <div className="footer-wrapper-primary">
      <div className="footer-content-wrap grid-col-4">
        <div>
          <h1>WAIMA</h1>
          <p>
            {language === 'es'
              ? 'La Fundación Waima se dedica a empoderar comunidades a través de la educación, el desarrollo sostenible y los programas sociales. Nos esforzamos por crear un cambio duradero apoyando iniciativas que eleven a las personas y promuevan un futuro mejor para todos.'
              : 'Waima Foundation is dedicated to empowering communities through education, sustainable development, and social programs. We strive to create lasting change by supporting initiatives that uplift individuals and promote a brighter future for all.'}
          </p>
        </div>

        <div>
          <h1>{language === 'es' ? 'Contactos' : 'Contacts'}</h1>

          <p className="footer-info-line1">
            <span className="label"> {language === 'es' ? 'Dirección: ' : 'Address: '} </span>
            <span className="value">Cra. 22 # 84AA-221, Bello Oriente - Manrique, <br/> Medellín, Antioquia, Colombia. </span>
          </p>
          <p className="footer-info-line2">
            <span className="label"> {language === 'es' ? 'Correo: ' : 'Email: '} </span>
            <span className="value">info@waimafundacion.org </span>

          </p>
          <p className="footer-info-line3">
            <span className="label"> {language === 'es' ? 'Celular: ' : 'Number:'} </span>
            <span className="value">+57 3137283858</span>
          </p>

        </div>

        <div>
          <h1 className="center-txt-768">
            {language === 'es' ? 'Redes Sociales' : 'Socials'}
          </h1>
          <div className="footer-interactive-wrapper">
            <Link
              className="footer-contact-interactive"
              target="_blank"
              to="https://www.instagram.com/fundacionwaima?igsh=cTgyNzEycnZubTdk"
            >
              <i className="pi pi-instagram" style={{ fontSize: '2.3rem' }}></i>
            </Link>
            <Link
              className="footer-contact-interactive"
              target="_blank"
              to="https://www.youtube.com/watch?v=v7Eilw0J_qo"
            >
              <i className="pi pi-youtube" style={{ fontSize: '2.3rem' }}></i>
            </Link>
            <Link
              className="footer-contact-interactive"
              target="_blank"
              to="https://www.facebook.com/fundacionwaima?rdid=UWhz0ZNFsFb6xIq1&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F18dDbxrTB4%2F#"
            >
              <i className="pi pi-facebook" style={{ fontSize: '2.3rem' }}></i>
            </Link>
          </div>
        </div>
        <Divider className="span-3 marginTop-2rem" />
        <p className="span-3 footer-copyright">
          © {language == 'es' ? 'FUNDACIÓN' : 'Foundation'} WAIMA- 2026
        </p>
      </div>
    </div>
  )
}
